import { Layout } from "@/modules/DashboardTemplate/models/Layout";
import { Vue } from "vue-property-decorator";

export function handleDragMove(
  event: Interact.DragEvent,
  el: HTMLElement,
  layout: Layout,
  margin: number,
  allowAutoGrow: boolean,
  limits?: { maxX?: number; maxY?: number }
) {
  const container = (el.closest?.(".dynamic-wrapper") ??
    el.parentElement) as HTMLElement;
  if (!container) return;
  container.offsetHeight;
  const parentRect = container.getBoundingClientRect();

  let newX = (layout?.x || 0) + event.dx;
  let newY = (layout?.y || 0) + event.dy;

  const maxX = limits?.maxX ?? parentRect.width - layout.width - margin;
  const maxY = limits?.maxY ?? parentRect.height - layout.height - margin;

  newX = Math.max(0, Math.min(newX, maxX));
  newY = allowAutoGrow ? Math.max(0, newY) : Math.max(0, Math.min(newY, maxY));

  Vue.set(layout, "x", newX);
  Vue.set(layout, "y", newY);
  el.style.transform = `translate(${newX}px, ${newY}px)`;
}
